import { ReactNode, useContext } from 'react';
import {
  AssociateSetupContext,
  AuthenticationContext,
  VsWebsocketProvider,
} from '@vs-online-only-app/state';
import { Navigate, useLocation } from 'react-router-dom';
import { CenteredLoader } from '@vs-online-only-app/ui';
import { Typography } from '@mui/material';
import {
  AssociateApprovedModal,
  AssociateSetToUnavailableModal,
  EndedConversations,
  IncomingConversations,
  OutgoingTransfers,
} from '@vs-online-only-app/chats';

type Props = {
  children: ReactNode;
};

const PrivateRoute = ({ children }: Props) => {
  const location = useLocation();
  const { isAuthenticated, verifyAuthenticatedState } = useContext(
    AuthenticationContext,
  );
  const { hasCompletedProfileSetup, hasCompletedIntroModules } = useContext(
    AssociateSetupContext,
  );

  if (['idle', 'loading', 'error'].includes(verifyAuthenticatedState)) {
    return (
      <CenteredLoader>
        <Typography variant="body1">
          {verifyAuthenticatedState === 'error'
            ? 'Authentication seems invalid. Page should reload within a few seconds.'
            : 'Verifying authentication'}
        </Typography>
      </CenteredLoader>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (location.pathname !== '/profile-setup' && !hasCompletedProfileSetup) {
    return <Navigate to="/profile-setup" replace />;
  }
  if (location.pathname !== '/introduction' && !hasCompletedIntroModules) {
    return <Navigate to="/introduction" replace />;
  }

  return (
    <VsWebsocketProvider>
      <IncomingConversations />
      <OutgoingTransfers />
      <EndedConversations />
      <AssociateSetToUnavailableModal />
      <AssociateApprovedModal />
      {children}
    </VsWebsocketProvider>
  );
};

export default PrivateRoute;
